export default __webpack_public_path__ + "static/media/arrow.96ac0c12.svg";